<!--
 * @Author: Gaho
 * @Date: 2024-02-28 14:27:05
 * @LastEditors: Gaho
 * @LastEditTime: 2025-01-21 17:11:54
 * @Description: corgiwild 游戏结果
-->
<template>
    <div
        class="corgiwild-result"
        :class="{
            'result-fast': isFast,
            'result-no-animation': !isAnimate,
        }"
    >
        <div class="result-wrap">
            <img class="result-lines" src="@/assets/imgs/casino/corgiwild/win-lines.webp" alt="" />
            <div class="result-coins-wrap">
                <div class="result-coins-sm" v-if="winType === 'win'">
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-sm.webp" alt="">
                    <img
                        class="result-coins" src="@/assets/imgs/casino/corgiwild/win-coin-sm.webp" alt=""
                    >
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-sm.webp" alt="">
                </div>
                <div class="result-coins-md" v-else-if="winType === 'bigWin'">
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-md.webp" alt="">
                    <img
                        class="result-coins" src="@/assets/imgs/casino/corgiwild/win-coin-md.webp" alt=""
                    >
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-md.webp" alt="">
                </div>
                <div class="result-coins-lg" v-else-if="winType === 'megaWin'">
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-lg.webp" alt="">
                    <img
                        class="result-coins" src="@/assets/imgs/casino/corgiwild/win-coin-lg.webp" alt=""
                    >
                    <img class="result-coins"
                        src="@/assets/imgs/casino/corgiwild/win-coin-lg.webp" alt="">
                </div>
            </div>
            <div class="result-img-wrap" v-if="winType !== 'win'">
                <img class="result-img-big-win"
                    v-if="winType === 'bigWin'"
                    src="@/assets/imgs/casino/corgiwild/big-win.webp" 
                    alt=""
                >
                <img class="result-img-mega-win"
                    v-else-if="winType === 'megaWin'"
                    src="@/assets/imgs/casino/corgiwild/mega-win.webp" alt="">
                <img
                    class="result-img-win" src="@/assets/imgs/casino/corgiwild/win-label.webp" alt="">
            </div>
            <div 
                class="result-win-wrap" 
                :class="{
                    'result-win-wrap-big-win': winType !== 'win'
                }"
            >
                <span class="result-win-char">x</span>
                <div class="result-sections">
                    <div
                        class="result-section"
                        v-for="(ele, ind) in multiLength"
                        :key="ind"
                        :style="`transform: translateY(${sectionPosition[ind]}px);transition-duration: ${dynamicTime}s`"
                    >
                        <div 
                            class="result-win-number"
                            v-for="(section, idx) in sections[ind]"
                            :key="idx"
                        >
                            {{ section }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="result-fiat-win">
                <img
                    class="result-fiat-win-bg"
                    src="@/assets/imgs/casino/corgiwild/win-fiat-bg.webp"
                    alt=""
                />
                <span class="currency result-fiat-win-value">
                    <CurrentCoin class="currency-icon" />
                    <span style="font-size: 27.7px">
                        <span style="color: #ffffff" class="font-digits">
                            {{ getFixed(result?.winAmount) }}
                        </span>
                    </span>
                </span>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import { winAmount, setAmountZero } from '@/pages/casino/plinkoGame/utils/index';
export default defineComponent({
    name: 'corgiwildResult',
    props: {
        isFast: {
            type: Boolean,
            default: false
        },
        isAnimate: {
            type: Boolean,
            default: false
        },
        winType: {
            type: String as PropType<'win' | 'bigWin' | 'megaWin'>,
            default: ''
        },
        multi: {
            type: Number,
            default: 0
        },
        result: {
            type: Object,
            default: () => ({})
        }
    },
    data(){
        return {
            sectionPosition: [5, 5, 5, 5],
            firstSectionTime: [{
                slow: .75,
                fast: .35
            }, {
                slow: 1.5,
                fast: .75
            }, {
                slow: 2.5,
                fast: 1.25
            }, {
                slow: 3.5,
                fast: 1.75
            }]
        }
    },
    computed: {
        // 动画持续时间
        dynamicTime() {
            return this.isAnimate ? this.firstSectionTime[String(this.multi).length - 1][this.isFast ? "fast" : "slow"] : 0
        },
        // 赢钱倍数的长度
        multiLength() {
            return String(this.multi).length
        },
        // [0, 1, 2, 4, 5]为了显示数字滚动的动画效果
        sections() {
            const sectionsData = [];
            Array.from(String(this.multi), Number).forEach((item, index) => {
                const childArr = [];
                const childArrLen = index === 0 ? (String(this.multi).length - 1) * 10 + item + 1 : item + 1;
                for (let i = 0; i < childArrLen; i++) {
                    childArr.push(i % 10);
                }
                sectionsData.push(childArr)
            })
            return sectionsData
        },
        // 滚动的位置
        sectionScroll() {
            const sectionPosition = [0, 0, 0, 0];
            this.sections.forEach((item, index) => {
                sectionPosition[index] = (item.length - 1) * -95 + 5
            });
            return sectionPosition
        }
    },
    mounted() {
        setTimeout(() => {
            this.sectionPosition = this.sectionScroll;
        }, 300)
    },
    methods: {
        winAmount,
        setAmountZero
    }
})
</script>
<style lang="scss" scoped>
.corgiwild-result {
    background: linear-gradient(180deg,#1d0700b3,#000f2b8f);
    bottom: 0;
    left: 0;
    padding: 10px 13px 15px 200px;
    position: absolute;
    right: -3px;
    top: 0;
    z-index: 9;
    pointer-events: none;
}

@media (max-width: 576px) {
    .corgiwild-result {
        padding:182px 12px 10px
    }
}

@media (max-width: 808px) {
    .left-aside-opened .corgiwild-result {
        padding:182px 12px 10px
    }
}

@media screen and (max-height: 740px) and (max-width:576px) {
    .corgiwild-result {
        padding:12px 12px 10px
    }
}

.corgiwild-result img {
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none
}

.result-fast .result-section {
    transition-delay: .1s;
    transition-duration: 1s;
    // width: 25px;
    min-width: 30px;
}

.result-fast .result-section:nth-child(2) {
    animation: section-show .5s linear .25s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: .75s;
    width: 0
}

.result-fast .result-section:nth-child(3) {
    animation: section-show .5s linear .75s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: 1.25s;
    width: 0
}

.result-fast .result-section:nth-child(4) {
    animation: section-show .5s linear 1.25s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: 1.75s;
    width: 0
}

.result-no-animation .result-section {
    transition-delay: 0s;
    transition-duration: 0s
}

.result-no-animation .result-section:nth-child(2),.result-no-animation .result-section:nth-child(3),.result-no-animation .result-section:nth-child(4) {
    animation: none !important;
    opacity: 1;
    overflow: visible;
    transition-delay: 0s;
    width: 25px
}

.result-no-animation .result-img-big-win,.result-no-animation .result-img-win {
    animation: none !important;
    transform: translate(-50%,-50%) scale(1)
}

.result-no-animation .result-img-big-win-hide {
    opacity: 0
}

.result-no-animation .result-img-mega-win {
    animation: none !important;
    transform: translate(-50%,-50%) scale(1)
}

.result-no-animation .result-win-wrap-big-win {
    animation: none !important;
    top: 55%
}

@media (max-width: 576px) {
    .result-no-animation .result-win-wrap-big-win {
        animation:none;
        top: 60%
    }
}

@media (max-width: 808px) {
    .left-aside-opened .result-no-animation .result-win-wrap-big-win {
        animation:none;
        top: 60%
    }
}

.result-no-animation .result-coins {
    animation: none;
    transform: translate(-50%,-50%) scale(1)
}

.result-no-animation .result-lines {
    animation: none
}

.result-wrap {
    animation: result-show .2s linear forwards;
    height: 100%;
    opacity: 0;
    position: relative;
    transform: scale(0);
    width: 100%
}

.result-wrap:before {
    background: #ffa800;
    top: 48%;
    transform: translate(-60%,-60%)
}

.result-wrap:after,
.result-wrap:before {
    border-radius: 30px;
    content: "";
    filter: blur(25px);
    height: 80px;
    left: 50%;
    position: absolute;
    width: 145px
}

.result-wrap:after {
    background: #ff3d00;
    top: 52%;
    transform: translate(-40%,-40%)
}

.result-win-wrap {
    align-items: flex-end;
    color: #fff;
    display: flex;
    font-family: Bebas Neue,cursive;
    font-size: 55px;
    font-weight: 700;
    left: 50%;
    line-height: 85px;
    position: absolute;
    text-rendering: optimizeLegibility;
    text-shadow: 0 5px 7px rgba(0,0,0,.5);
    top: 50%;
    transform: translate(-50%,-50%);
    word-spacing: -30px;
    z-index: 5
}

.result-win-wrap-big-win {
    animation: win-amount-down .6s linear .8s forwards
}

@media (max-width: 576px) {
    .result-win-wrap-big-win {
        animation:win-amount-down-mobile .6s linear .8s forwards
    }
}

@media (max-width: 808px) {
    .left-aside-opened .result-win-wrap-big-win {
        animation:win-amount-down-mobile .6s linear .8s forwards
    }
}

.result-win-char {
    font-size: 35px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 31px;
    margin-right: 5px;
    text-shadow: none
}

.result-lines {
    animation: roll 6s linear infinite;
    animation-delay: .2s;
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%) rotate(0)
}

.result-coins-wrap {
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%
}

.result-coins {
    animation: coins-fly 1s linear infinite;
    left: 50%;
    opacity: 1;
    pointer-events: none;
    position: absolute;
    top: 50%;
    transform: translate(-50%,-50%) scale(0);
    -webkit-user-select: none;
    -moz-user-select: none;
    user-select: none
}

.result-coins-sm .result-coins:first-child {
    animation-delay: .5s
}

.result-coins-sm .result-coins:nth-child(2) {
    animation-delay: .8s
}

.result-coins-sm .result-coins:nth-child(3) {
    animation-delay: 1.1s
}

.result-coins-md .result-coins:first-child {
    animation-delay: 1s
}

.result-coins-md .result-coins:nth-child(2) {
    animation-delay: 1.3s
}

.result-coins-md .result-coins:nth-child(3) {
    animation-delay: 1.6s
}

.result-coins-lg .result-coins:first-child {
    animation-delay: 1.2s
}

.result-coins-lg .result-coins:nth-child(2) {
    animation-delay: 1.4s
}

.result-coins-lg .result-coins:nth-child(3) {
    animation-delay: 1.7s
}

.result-sections {
    display: flex;
    -webkit-mask-image: linear-gradient(180deg,transparent,#000 15px,#000 calc(100% - 15px),transparent),linear-gradient(#000,#000);
    -webkit-mask-position: 0 0,100% 0;
    -webkit-mask-repeat: no-repeat,no-repeat;
    -webkit-mask-size: 100% 100%,0 100%;
    max-height: 100px;
    overflow: hidden
}

.result-section {
    transition-delay: .3s;
    transition-duration: 1.5s;
    // width: 25px;
    min-width: 30px;
}

.result-section:nth-child(2) {
    animation: section-show 1s linear .5s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: 1.5s;
    width: 0
}

.result-section:nth-child(3) {
    animation: section-show 1s linear 1.5s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: 2.5s;
    width: 0
}

.result-section:nth-child(4) {
    animation: section-show 1s linear 2.5s forwards;
    opacity: 0;
    overflow: hidden;
    transition-delay: 3.5s;
    width: 0
}

.result-win-number {
    margin-bottom: 10px
}

.result-img-wrap {
    height: 100%;
    left: 0;
    pointer-events: none;
    position: absolute;
    top: 0;
    width: 100%;
    z-index: 3
}

.result-img-win {
    animation: win-label-show .2s linear 1s forwards;
    top: 40%
}

.result-img-big-win,.result-img-win {
    left: 50%;
    position: absolute;
    transform: translate(-50%,-50%) scale(0)
}

.result-img-big-win {
    animation: win-label-show .2s linear .8s forwards,pulse 1s linear 1s infinite;
    top: 30%
}

.result-img-big-win-hide {
    animation: win-label-show .2s linear .8s forwards,pulse 1s linear 1s infinite,win-label-hide .2s linear 2s forwards
}

.result-img-mega-win {
    animation: win-label-show .2s linear 2s forwards,pulse 1s linear 2.2s infinite;
    left: 50%;
    position: absolute;
    top: 30%;
    transform: translate(-50%,-50%) scale(0)
}

.result-fiat-win {
    left: 50%;
    position: absolute;
    top: 56%;
    transform: translate(-50%);
    z-index: 6
}

.result-fiat-win-mega .result-fiat-win-bg {
    animation-delay: 2.2s
}

.result-fiat-win-mega .result-fiat-win-value {
    animation-delay: 2.5s
}

@media (max-width: 576px) {
    .result-fiat-win {
        top:67%
    }
}

@media (max-width: 808px) {
    .left-aside-opened .result-fiat-win {
        top:67%
    }
}

.result-fiat-win-bg {
    animation: bg-fiat-show .3s linear .5s forwards;
    box-shadow: 0 7.38129px 9.84173px #00000073;
    max-width: 0;
    min-height: 36px
}

.result-fiat-win-value {
    animation: value-fiat-show .3s linear .8s forwards;
    display: flex;
    justify-content: center;
    left: 50%;
    opacity: 0;
    position: absolute;
    top: 55%;
    transform: translate(-50%,20px);
    width: 100%;
    align-items: center;

    .currency-icon {
        width: 27px;
        height: 27px
    }
}

.result-fiat-win-value span {
    font-family: Bebas Neue,cursive;
    font-size: 28px!important;
    font-weight: 500
}
@keyframes value-fiat-show {
    to {
        opacity: 1;
        transform: translate(-50%,-50%)
    }
}

@keyframes bg-fiat-show {
    to {
        max-width: 180px
    }
}
@keyframes result-show {
    to {
        opacity: 1;
        transform: scale(1)
    }
}
@keyframes pulse {
    0% {
        transform: translate(-50%,-50%) scale(1)
    }

    50% {
        transform: translate(-50%,-50%) scale(1.1)
    }

    to {
        transform: translate(-50%,-50%) scale(1)
    }
}

@keyframes win-amount-down {
    to {
        top: 52%
    }
}

@keyframes win-amount-down-mobile {
    to {
        top: 58%
    }
}

@keyframes win-label-show {
    80% {
        transform: translate(-50%,-50%) scale(1.1)
    }

    to {
        transform: translate(-50%,-50%) scale(1)
    }
}

@keyframes win-label-hide {
    to {
        opacity: 0
    }
}

@keyframes section-show {
    50% {
        width: 0
    }

    90% {
        opacity: 0;
        width: 25px
    }

    to {
        opacity: 1;
        overflow: visible;
        width: 25px
    }
}

@keyframes coins-fly {
    0% {
        opacity: 1;
        transform: translate(-50%,-50%) scale(0)
    }

    80% {
        opacity: 1
    }

    to {
        opacity: 0;
        transform: translate(-50%,-50%) scale(1)
    }
}

@keyframes roll {
    to {
        transform: translate(-50%,-50%) rotate(1turn)
    }
}
</style>